import { useParams } from "react-router-dom";
import { UniversalPricingEditPanel, UniversalPricingViewPanel } from "@/components/organisms";

export const UniversalPricing = () => {
  const { mode } = useParams();

  return <div className="contents">{mode === "edit" ? <UniversalPricingEditPanel /> : <UniversalPricingViewPanel />}</div>;
};
